import moment from 'moment-timezone';

const getMomentFormat = (date, format, tz) => moment(date).tz(tz).format(format);
export default getMomentFormat;
